if (!customElements.get('direct-buy-button')) {
  customElements.define(
    'direct-buy-button',
    class DirectBuyButton extends HTMLElement {
      connectedCallback() {
        if (this.dataset.directBuyReady === 'true') return;

        this.dataset.directBuyReady = 'true';
        this.addEventListener('click', this.onClickHandler.bind(this));
      }

      onClickHandler(event) {
        if (!(event.target instanceof Element)) return;

        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        const form = document.getElementById(this.dataset.formId);
        if (!form) return;

        const formData = new FormData(form);
        const variantId = String(formData.get('id') || this.dataset.variantId || '');
        const quantityInput = Array.from(document.querySelectorAll('input[name="quantity"]')).find(
          (input) => input.getAttribute('form') === this.dataset.formId
        );
        const requestedQuantity = Number.parseInt(
          String(formData.get('quantity') || quantityInput?.value || '1'),
          10
        );
        const quantity = Number.isFinite(requestedQuantity) && requestedQuantity > 0 ? requestedQuantity : 1;

        if (!/^\d+$/.test(variantId)) return;

        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        button.querySelector('.loading__spinner')?.classList.remove('hidden');

        const rootUrl = this.dataset.rootUrl || '/';
        const localizedRoot = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
        window.location.assign(`${localizedRoot}cart/${variantId}:${quantity}`);
      }
    }
  );
}
